import { type Components, type Theme } from "@mui/material/styles";

export const radio: Components<Theme>["MuiRadio"] = {
  defaultProps: {
    size: "small",
  },
};
